const formatPhoneNumber = (phoneNumber: string) => {
  const hasPrefix = phoneNumber.startsWith('+48');

  const cleaned = phoneNumber.replace(/\D/g, '');

  const nationalNumber = hasPrefix ? cleaned.slice(2) : cleaned;

  const match = nationalNumber.match(/^(\d{3})(\d{2})(\d{2})(\d{2})$/);

  if (match) {
    return hasPrefix
      ? `+48 ${match[1]} ${match[2]} ${match[3]} ${match[4]}`
      : `${match[1]} ${match[2]} ${match[3]} ${match[4]}`;
  }

  return phoneNumber;
};

export default formatPhoneNumber;
